import { render, staticRenderFns } from "./videoCat-videos.vue?vue&type=template&id=67c2b71f&scoped=true&"
import script from "./videoCat-videos.vue?vue&type=script&lang=js&"
export * from "./videoCat-videos.vue?vue&type=script&lang=js&"
import style0 from "./videoCat-videos.vue?vue&type=style&index=0&id=67c2b71f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2b71f",
  null
  
)

export default component.exports